/** Wizard de workspace: elige grupo empresa → empresa → sucursal mostrando sólo los pasos que el usuario necesita. Al terminar guarda la sucursal activa (y el contexto de empresa) y navega al módulo por defecto. */
import React from "react";
import { Button, Empty, Spin, Steps } from "antd";
import { MdBusiness, MdLogout } from "react-icons/md";
import { useWorkspaceWizard } from "./useWorkspaceWizard";
import "./selectWorkspace.css";

const SelectWorkspace: React.FC = () => {
  const {
    loggedUserInnerwork,
    darkMode,
    paso,
    pasos,
    pasoActual,
    cargando,
    mostrarSpinner,
    grupos,
    empresas,
    sucursales,
    grupoElegido,
    empresaElegida,
    nombreEmpresaContexto,
    nombreUsuario,
    cerrando,
    renderOpciones,
    volver,
    continuarSinSucursal,
    cerrarSesion,
  } = useWorkspaceWizard();

  return (
    <div className="select-workspace-wrapper">
      <div className="select-workspace-topbar">
        <div className="select-workspace-logo">
          <img
            src={darkMode ? "/innercor-blanco.svg" : "/innercor-color.svg"}
            alt="Innercor"
            width={190}
          />
        </div>
      </div>

      <div className="select-workspace-card">
        <h1 className="select-workspace-greeting">Hola, {nombreUsuario}</h1>
        <p className="select-workspace-subtitle">
          {pasoActual.key === "sucursal" && nombreEmpresaContexto ? (
            <>
              <span className="select-workspace-empresa">
                <MdBusiness style={{ marginRight: 6, verticalAlign: "middle" }} />
                {nombreEmpresaContexto}
              </span>
              Elegí tu sucursal de trabajo
            </>
          ) : (
            pasoActual.subtitulo
          )}
        </p>

        {pasos.length > 1 && (
          <Steps
            size="small"
            current={paso}
            items={pasos.map((p) => ({ title: p.titulo }))}
            className="select-workspace-steps"
          />
        )}

        <div key={pasoActual.key} className="select-workspace-list">
          {renderOpciones()}
        </div>

        {pasoActual.key === "sucursal" && (
          <div className="select-workspace-skip">
            <Button block onClick={continuarSinSucursal}>
              Continuar sin sucursal
            </Button>
          </div>
        )}

        {paso > 0 && (
          <div className="select-workspace-actions">
            <Button type="link" onClick={volver}>
              Volver
            </Button>
          </div>
        )}

        <div className="select-workspace-logout">
          <Button
            type="text"
            icon={<MdLogout size={16} />}
            loading={cerrando}
            onClick={cerrarSesion}
          >
            {cerrando ? "Cerrando sesión..." : "Cerrar sesión"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectWorkspace;
